'use client';

import { AppBar as MuiAppBar } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

import type { AppBarProps as MuiAppBarProps } from '@mui/material';

export interface AppBarProps extends MuiAppBarProps {
  isTransparent?: boolean;
  isScrolling?: boolean;
  height?: number;
}

const StyledAppBar = styled( MuiAppBar, {
  shouldForwardProp: (prop) =>
    prop !== 'isTransparent' && prop !== 'isScrolling' && prop !== 'height',
} )<AppBarProps>(({ isTransparent, isScrolling, height = 0, theme }) => ({
  // ...isScrolling && {
  //   boxShadow: `-23px 16px 56px -8px ${alpha(
  //     theme.palette.mode === 'light' ? theme.palette.grey[500] : theme.palette.common.black,
  //     1
  //   )}`,
  // }
}));

/**
 * Styled Wrapper for list like elements (navbar etc...)
 * Can be opaque or transparent
 * adds a custom Shadow when scrolling
 */
export const AppBar = StyledAppBar;
